import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getLocalKey } from '../../../utils/commonfunction';
import { setGlobalLoader } from '../../../redux/slices/globalLoader';
import { useDispatch, useSelector } from 'react-redux';
import GlobalLoader from './globalLoader';
import { ROLE } from '../../../utils/Constants'

const BusinessPublicRoute = ({ component: Component }) => {
    const dispatch = useDispatch();
    const loaderState = useSelector((state) => state.globalLoader);

    const businessData = getLocalKey(ROLE.BUSINESS) ? JSON.parse(getLocalKey(ROLE.BUSINESS)) : {};

    useEffect(() => {
        Promise.all([import('rsuite/dist/rsuite.min.css'),
        import('bootstrap/dist/css/bootstrap.min.css'),
        import("../../../assets/admin/plugins/fancyuploder/fancy_fileupload.css")]).then(() => {
            dispatch(setGlobalLoader(false));
        })
    }, []);

   return (
  <>
    {loaderState ? (
      <GlobalLoader />
    ) : businessData && businessData.token && businessData.role === ROLE.BUSINESS ? (
      <Navigate to="/business/dashboard" />
    ) : (
      <Component />
    )}
  </>
);

}

export default BusinessPublicRoute;